import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';
import React from 'react';
// ----------------------------------------------------------------------

export default function Select(containerId: string) {
  return {
    MuiSelect: {
      defaultProps: {
        container: document.getElementById(containerId),
        IconComponent: (props: any) => (
          <ExpandMoreRoundedIcon
            id={'arrow-select'}
            {...props}
            style={{ top: 'unset', fontSize: 24 }}
          />
        ),
      },

      styleOverrides: {
        root: {
          // '& .MuiInputBase-input': {
          //   fontSize: '14px!important',
          //   color: ' rgb(56, 56, 56)!important',
          //   padding: '17px 20px!important',
          // },
        },
        '& .MuiSvgIcon-root': {
          fontSize: 16,
        },
      },
    },
  };
}
